import { useState, useEffect, useCallback } from 'react';
import { LOCATION_SEARCH_DATA_CHANGE_EVENT } from '../../constants';
import { FilterTypes } from '../../constants/initialFilters';
import { cleanModelFamilies } from '../../utils/cleanModelFamilies';

const loadLsData = (): FilterTypes | undefined => {
  const stringified = localStorage.getItem('selectedFilters-v5');

  if (!stringified) return undefined;

  try {
    const parsed = JSON.parse(stringified) as FilterTypes;
    const cleanedData: FilterTypes = {
      ...parsed,
      modelFamily: cleanModelFamilies(parsed.modelFamily),
    };

    return cleanedData;
  } catch (e) {
    return undefined;
  }
};

type UseSelectedDealersType = () => FilterTypes | undefined;

const useGetFiltersFromLS: UseSelectedDealersType = () => {
  const [filterData, setFilterData] = useState<FilterTypes | undefined>(loadLsData);

  const onFilterDataChanged = useCallback(() => {
    setFilterData(loadLsData);
  }, []);

  // Effect responsible for adding/removing event listener
  useEffect(() => {
    document.addEventListener(LOCATION_SEARCH_DATA_CHANGE_EVENT, onFilterDataChanged);

    return () => {
      document.removeEventListener(LOCATION_SEARCH_DATA_CHANGE_EVENT, onFilterDataChanged);
    };
  }, [onFilterDataChanged]);

  return filterData;
};

export default useGetFiltersFromLS;
